import { Injectable } from '@angular/core';
import { LoadingController, ToastController, AlertController } from 'ionic-angular';
import 'rxjs/add/operator/map';

@Injectable()
export class LoadingProvider {

    constructor(public loadingCtrl: LoadingController, private toastCtrl: ToastController, private alertCtrl: AlertController) { }

    loading: any;

    Start() {
        this.loading = this.loadingCtrl.create({
            content: 'اندکی صبر ...'
        });

        this.loading.present();
    }

    Stop() {
        this.loading.dismiss();
    }

    ShowMessage(msg) {
        let messageText: string;

        var i; for (i = 0; i < msg.length; i++) {
            if (messageText == null) {
                messageText = msg[i].Error.Messages[0].Message;
            }
            else {
                messageText += '  -  ' + msg[i].Error.Messages[0].Message;
            }
        }

        let toast = this.toastCtrl.create({
            message: messageText,
            duration: 3000,
            position: 'top',
            dismissOnPageChange: true
        });

        toast.onDidDismiss(() => {
            console.log('توقف ...');
        });

        toast.present();
    }

    ShowInfoMessage(msg: string) {

        let toast = this.toastCtrl.create({
            message: msg,
            duration: 5000,
            position: 'top',
            showCloseButton: true,
            closeButtonText: 'X',
            dismissOnPageChange: true
        });

        toast.onDidDismiss(() => {
            console.log('توقف ...');
        });

        toast.present();
    }

    ShowConfirm(title, msg, agreeButtonText, disagreeButtonText) {
        const confirm = this.alertCtrl.create({
            title: title,
            message: msg,
            buttons: [
                {
                    text: disagreeButtonText,
                    handler: () => {
                        return true;
                    }
                },
                {
                    text: agreeButtonText,
                    handler: () => {
                        return false;
                    }
                }
            ]
        });
        confirm.present();
    }
}



// WEBPACK FOOTER //
// ./src/providers/LoadingProvider.ts